import { TemplatePage } from './types';

const live_streaming_remote_work_theme: TemplatePage = {
  header: {
    color: '#FFF079',
    icon: 'images/video-templates/technology-computers.jpg',
    title: 'Live Stream Templates — Remote Work Theme',
    title_meta: 'Free Live Stream Overlay Templates — Remote Work Theme',
    description_meta:
      'Make your live streams look and feel professional with Wave.video’s customizable remote-work-themed overlay templates.',
    description:
      'Make your live streams look and feel professional with this collection of easily editable remote-work-themed templates.' +
      ' Create branded overlays, intros & outros, lower thirds, and thumbnails in a matter of minutes'
  },
  footer: {
    category: 'Live Stream Remote Work Theme',
    description:
      'Thanks to Wave.video’s collection of easy-to-customize themed templates, you can upgrade your live streams and make them' +
      ' look more professional with no effort. Leave your online audience in awe with well-thought-out intros, outros, overlays,' +
      ' thumbnails, and lower thirds without the need to hire expensive video editors. Take your next big step towards becoming a'+
      ' top-notch live streamer!'
  },
  content: [
    {
      type: 'templates',
      title: 'Live Stream Templates — Remote Work Theme',
      search: { name: 'RemoteWorkTheme', tags: 'RemoteWorkTheme' }
    },
    { type: 'calendar' }
  ]
};

export default live_streaming_remote_work_theme;
